import L from 'leaflet';
import d3 from 'd3';
import RBush from 'rbush';
// require('./canvasOverlay/L.CanvasOverlay.js');

export default class Markers {

  constructor(lmap, layer, opts) {
    this._archiveLayer = layer;
    this._lmap = lmap;

    this._maxRadius = 40;
    this._minRadius = 1.5;
    this._maxAlpha = 1;
    this._minAlpha = 0.8;
    this._canvases = [];

    var that = this;
    this._markersLayer = L.tileLayer.canvas({
      async: true,
      updateWhenIdle:true,
      detectRetina:true,
      tileSize: 512,
      maxZoom: 20
    });
    this._markersLayer.drawTile = function(canvas, tile, zoom) {
      that.drawingOnCanvas(canvas, tile, zoom, this);
    }
    this._ratio = this._getPixelRatio();
    this._rTree = new RBush(9);
    this._markersLayer.addTo(this._lmap);
  }

  _getPixelRatio() {
    const c = document.createElement('canvas');
    const ctx = c.getContext('2d');
    const devicePixelRatio = window.devicePixelRatio || 1;
    const backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
                            ctx.mozBackingStorePixelRatio ||
                            ctx.msBackingStorePixelRatio ||
                            ctx.oBackingStorePixelRatio ||
                            ctx.backingStorePixelRatio || 1;
    return devicePixelRatio / backingStoreRatio;
  }

  drawingOnCanvas(canvas, tile, zoom, tileLayer) {
    var ctx = canvas.getContext('2d');
    canvas.style.width = canvas.width + 'px';
    canvas.style.height = canvas.width + 'px';
    canvas.width *= this._ratio;
    canvas.height *= this._ratio;

    var tileSize = tileLayer.options.tileSize;
    var start = tile.multiplyBy(tileSize);
    var minLatLng = this._lmap.unproject([start.x-40, start.y-40], zoom);
    var maxLatLng = this._lmap.unproject([start.x+tileSize+40, start.y+tileSize+40], zoom);

    ctx.fillStyle = 'rgba(131, 120, 244, 1)';
    var rs = this._rTree.search([maxLatLng.lat, minLatLng.lng, minLatLng.lat, maxLatLng.lng]);
    for (const d of rs) {
      const row = d[4];
      var p = this._lmap.project([row.lat, row.lng]);
      var x = p.x - start.x;
      var y = p.y - start.y;
      const radius = Math.floor(this._radiusScale(row.value));

      if (zoom<13  && radius<10 && Math.random()<0.8) continue;
      if (zoom==14 && radius<10 && Math.random()<0.6) continue;
      if (zoom==15 && radius<5  && Math.random()<0.2) continue;
      
      ctx.globalAlpha = this._alphaScale(row.value);
      ctx.beginPath();
      ctx.arc(x * this._ratio, y * this._ratio, radius * this._ratio, 0, Math.PI * 2, true, true);
      ctx.closePath();
      ctx.fill();
    }
    tileLayer.tileDrawn(canvas);
  }

  updateData(data) {
    if (!data) return;
    this._data = data;
    const maxValue = d3.max(this._data, d => d.value);
    const minValue = d3.min(this._data, d => d.value);
    this._radiusScale = d3.scale.pow().exponent(.5).domain([minValue, maxValue]).range([this._minRadius, this._maxRadius]);
    this._alphaScale = d3.scale.log().domain([minValue, maxValue]).range([this._maxAlpha, this._minAlpha]);
    this._nodes = this._data.map(d => [d.lat, d.lng, d.lat, d.lng, d]).filter(d => !isNaN(d[0]));
    this._rTree.clear();
    this._rTree.load(this._nodes);

    this._markersLayer.redraw();
  }

  // getBounds() {
  //   return this._markersLayer.getBounds();
  // }

  // clear() {
  //   this._markersLayer.clearLayers();
  // }

  hide() {
    this._archiveLayer.removeLayer(this._markersLayer);
  }

  show() {
    this._archiveLayer.addLayer(this._markersLayer);
  }

}



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/views/map/MarkersTiledCanvas.es6
 **/